import { type } from '@/utils/type'

export const UI_CLOSE_SNACKBAR = type('UI_CLOSE_SNACKBAR')
export const UI_ADD_SNACK_MESSAGE = type('UI_ADD_SNACK_MESSAGE')

export const UI_SET_CONTENT_HEIGHT = type('UI_SET_CONTENT_HEIGHT')

export const UI_CLOSE_ERROR = type('UI_CLOSE_ERROR')
export const UI_ERROR_MESSAGE = type('UI_ERROR_MESSAGE')

export const UI_SET_SEARCH_FLUX = type('UI_SET_SEARCH_FLUX')
export const UI_SET_SORT_FLUX_DESC = type('UI_SET_SORT_FLUX_DESC')
export const UI_SET_SORT_FLUX_BY = type('UI_SET_SORT_FLUX_BY')

export const UI_SET_SEARCH_PARTENAIRE = type('UI_SET_SEARCH_PARTENAIRE')
export const UI_SET_SORT_PARTENAIRE_DESC = type('UI_SET_SORT_PARTENAIRE_DESC')
export const UI_SET_SORT_PARTENAIRE_BY = type('UI_SET_SORT_PARTENAIRE_BY')

export const UI_SET_SEARCH_DATASOURCE = type('UI_SET_SEARCH_DATASOURCE')
export const UI_SET_SORT_DATASOURCE_DESC = type('UI_SET_SORT_DATASOURCE_DESC')
export const UI_SET_SORT_DATASOURCE_BY = type('UI_SET_SORT_DATASOURCE_BY')

export const UI_SET_SEARCH_FEEDDOWNLOAD = type('UI_SET_SEARCH_FEEDDOWNLOAD')
export const UI_SET_SORT_FEEDDOWNLOAD_DESC = type('UI_SET_SORT_FEEDDOWNLOAD_DESC')
export const UI_SET_SORT_FEEDDOWNLOAD_BY = type('UI_SET_SORT_FEEDDOWNLOAD_BY')

export const UI_SET_SEARCH_FLUXBUILDER = type('UI_SET_SEARCH_FLUXBUILDER')
export const UI_SET_SORT_FLUXBUILDER_DESC = type('UI_SET_SORT_FLUXBUILDER_DESC')
export const UI_SET_SORT_FLUXBUILDER_BY = type('UI_SET_SORT_FLUXBUILDER_BY')

export const UI_SET_SEARCH_META = type('UI_SET_SEARCH_META')
export const UI_SET_SORT_META_DESC = type('UI_SET_SORT_META_DESC')
export const UI_SET_SORT_META_BY = type('UI_SET_SORT_META_BY')

export const UI_SET_SEARCH_PERSONNE = type('UI_SET_SEARCH_PERSONNE')
export const UI_SET_SORT_PERSONNE_DESC = type('UI_SET_SORT_PERSONNE_DESC')
export const UI_SET_SORT_PERSONNE_BY = type('UI_SET_SORT_PERSONNE_BY')

export const UI_SET_SEARCH_PROFIL_EXCLUSION = type('UI_SET_SEARCH_PROFIL_EXCLUSION')
export const UI_SET_SORT_PROFIL_EXCLUSION_DESC = type('UI_SET_SORT_PROFIL_EXCLUSION_DESC')
export const UI_SET_SORT_PROFIL_EXCLUSION_BY = type('UI_SET_SORT_PROFIL_EXCLUSION_BY')

export const UI_SET_SEARCH_GROUP_CARAC = type('UI_SET_SEARCH_GROUP_CARAC')
export const UI_SET_SORT_GROUP_CARAC_DESC = type('UI_SET_SORT_GROUP_CARAC_DESC')
export const UI_SET_SORT_GROUP_CARAC_BY = type('UI_SET_SORT_GROUP_CARAC_BY')

export const UI_SET_FILTER_GROUPID = type('UI_SET_FILTER_GROUPID')
export const UI_SET_FILTER_DBNAME = type('UI_SET_FILTER_DBNAME')
export const UI_SET_FILTER_DBKEY = type('UI_SET_FILTER_DBKEY')
export const UI_SET_FILTER_TYPE = type('UI_SET_FILTER_TYPE')